// extracted by mini-css-extract-plugin
export default {"active":"active__sU2zY","prevNextBtn":"prevNextBtn__7fU8V"};